
import React from "react";
import "./About3.css"
import {FiArrowLeftCircle} from "react-icons/fi";
import { Link } from "react-router-dom";

const About3 = () => {
  return (
    <div>
        <div className="landing-about-container">
          <div className="only-text-box">
            <h2>About NYSC SAED </h2>
            <p>Other functions of the SAED Department include:</p>
            <ul className="about-list1">
                <li>Promote public-private partnership for entrepreneurship development and self-reliance amongst Nigerian youths</li>
                <li>Promote documentation and sharing of best practices on youth empowerment in Nigeria</li>
                <li>Support evidence-driven advocacy efforts for favorable policies on youth empowerment in Nigeria</li>
                <li>Development of a standard curriculum for the in-camp skill acqusition exercise</li>
                <li>Identification of organizations at state level to provide training and mentoring in specific skills sets</li>
                <li>Attachment of the corps members to the various organizations for skill acquisition and entrepreneurship development</li>
                <li>On-going monitoring and supervision of trainee corps members</li>
                <li>Facilitate access to available funding opportunities</li>
            </ul>
            
                <div className="left-arrow"><Link to ="/about2" ><FiArrowLeftCircle size={40} style={{color: "#979797"}} /></Link></div>
                
          </div>
          
          
        </div>
    </div>
  )
}

export default About3